import { render } from "./EconomyPostingsTabs.vue?vue&type=template&id=269a3aaa&ts=true"
import script from "./EconomyPostingsTabs.vue?vue&type=script&lang=ts"
export * from "./EconomyPostingsTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__